import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CabinetCard from './CabinetCard';

class Cabinet extends Component {
  adjustHeight = () => {
    console.log('adjusting height');

    setTimeout(() => {
      window.pymChild.sendHeight();
    }, 500);
  };

  render() {
    {
      this.adjustHeight();
    }
    return this.props.candidates.map(pick => (
      <CabinetCard key={pick.id} pick={pick} />
    ));
  }
}

// Proptypes
Cabinet.propTypes = {
  candidates: PropTypes.array.isRequired,
};
export default Cabinet;
